import React, { useState } from "react";
import "./OutstandingResults.css";
import alligner from "./alligner.png";
import clean from "./clean.png";
import whiten from "./whiten.png";
import gleamguards from "./gleam.png";
import cw from "./media/braces2.jpg";
import implant from "./media/implant2.jpg";
import crown from "./media/crown1.jpg";
const ResultsSection = () => {
  const options = [
    "Aligners",
    "Braces",
    "Dental Implant",
    "Whitening",
    "Crown & Bridge",
  ];
  const [selected, setSelected] = useState(options[0]);

  const content = {
    "Aligners": {
      title: "Perfectly Aligned Smiles with PrimeMax Aligners",
      description:
        "We offer fully customized clear aligners in Guwahati designed using advanced digital scanning and 3D treatment planning. Each set of trays is crafted for accuracy, comfort, and predictable movement, helping your teeth shift gradually without metal brackets or wires. Our team monitors your progress closely, ensuring your smile transforms smoothly while fitting effortlessly into your daily routine.",
      image: alligner,
    },
    "Braces": {
      title: "Align Your Future: The Braces Journey",
      description:
        "Straighten your smile with confidence through our modern orthodontic treatments in Guwahati, including traditional braces and clear aligners. We create a personalized plan to align your teeth comfortably and effectively, at any age.",
      image: cw,
    },
    "Dental Implant": {
      title: "Restore Your Foundation: The Dental Implant Solution",
      description:
        "Dental implants offer the most natural, durable, and permanent solution for missing teeth. They are surgically placed to replace the tooth root, fusing directly with your jawbone to preserve bone density and support a lifetime smile",
      image: implant,
    },
    Whitening: {
      title: "Professional Teeth Whitening for Radiant Smiles",
      description:
        "Get instant results with our advanced whitening treatments. We use safe, enamel-friendly formulas for noticeably whiter teeth without sensitivity.",
      image: whiten,
    },
    "Crown & Bridge": {
      title: "Durable, natural-looking restorations crafted for strength and beauty.",
      description:
        "Our dental crown and bridge treatments in Guwahati restore damaged or missing teeth with durable, natural-looking results. Custom-crafted for a precise fit, they blend seamlessly with your smile while restoring full function for everyday comfort.",
      image: crown,
    },
  };

  return (
    <div className="results-container">
      <div className="options-bar">
        {options.map((option) => (
          <button
            key={option}
            className={`option-btn ${selected === option ? "active" : ""}`}
            onClick={() => setSelected(option)}
          >
            {option.toUpperCase()}
          </button>
        ))}
      </div>

      <div className="result-content">
        <div className="result-text">
          <h2>{content[selected]?.title ?? "Select a service"}</h2>
          <p>{content[selected]?.description ?? "Choose a service to see more details."}</p>
        </div>
        {content[selected]?.image && (
          <img
            src={content[selected]?.image}
            alt={selected}
            className="result-image"
          />
        )}
      </div>
    </div>
  );
};

export default ResultsSection;
